import { RsvpStatus as RsvpStatusV1 } from '@wix/ambassador-events-v1-rsvp/types';
import { RsvpStatus as RsvpStatusV2 } from '@wix/ambassador-events-v2-rsvp/types';
import { RsvpStatus } from '@wix/events-types';
import { isWaitlistOpen } from './event';
export const isRsvpV2 = (rsvp) => rsvp?.revision !== undefined;
export const getRsvpFormInputValues = (rsvp) => isRsvpV2(rsvp) ? rsvp.form?.inputValues : rsvp.rsvpForm?.inputValues;
export const isRsvpStatusWaitlist = (status) => status === RsvpStatusV2.WAITLIST || status === RsvpStatus.WAITING || status === RsvpStatusV1.WAITING;
export const isRsvpStatusYes = (status) => status === RsvpStatusV2.YES || status === RsvpStatus.YES || status === RsvpStatusV1.YES;
export const isRsvpStatusNo = (status) => status === RsvpStatusV2.NO || status === RsvpStatus.NO || status === RsvpStatusV1.NO;
export const mapRsvpStatusToV2 = (status) => {
    switch (status) {
        case RsvpStatus.NO:
        case RsvpStatusV1.NO:
            return RsvpStatusV2.NO;
        case RsvpStatus.WAITING:
        case RsvpStatusV1.WAITING:
            return RsvpStatusV2.WAITLIST;
        case RsvpStatus.YES:
        case RsvpStatusV1.YES:
        default:
            return RsvpStatusV2.YES;
    }
};
export const isRsvpAnonymous = (rsvp) => rsvp.anonymized;
export const getRsvpForm = (rsvp) => (isRsvpV2(rsvp) ? rsvp.form : rsvp.rsvpForm);
export const hasRsvpAdditionalGuests = (rsvp) => getRsvpGuestAmount(rsvp) > 1;
export const getRsvpAdditionalGuests = (rsvp) => getRsvpGuests(rsvp).slice(1);
export const getRsvpGuestsIds = (rsvp) => getRsvpGuests(rsvp).map(getRsvpGuestId);
export const getNotCheckedInRsvpGuests = (rsvp) => getRsvpGuests(rsvp).filter(guest => !isGuestCheckedIn(guest));
export const getNotCheckedInRsvpGuestIds = (rsvp) => getNotCheckedInRsvpGuests(rsvp).map(getRsvpGuestId);
export const isRsvpFullyCheckedIn = (rsvp) => getRsvpGuests(rsvp).every(isGuestCheckedIn);
export const isAnyRsvpGuestCheckedIn = (rsvp) => getRsvpGuests(rsvp).some(isGuestCheckedIn);
export const getRsvpCreatedDate = (rsvp) => (isRsvpV2(rsvp) ? rsvp.createdDate : rsvp.created);
export const getRsvpGuests = (rsvp) => (isRsvpV2(rsvp) ? rsvp?.guestList?.guests : rsvp?.guests) ?? [];
export const getRsvpGuestAmount = (rsvp) => getRsvpGuests(rsvp).length;
export const getCheckedInRsvpGuests = (rsvp) => getRsvpGuests(rsvp).filter(isGuestCheckedIn);
export const getCheckedInRsvpGuestIds = (rsvp) => getCheckedInRsvpGuests(rsvp).map(getRsvpGuestId);
export const getCheckedInRsvpGuestAmount = (rsvp) => getCheckedInRsvpGuests(rsvp).length;
export const isGuestV2 = (guest) => guest?.guestId !== undefined;
export const isGuestCheckedIn = (guest) => Boolean(isGuestV2(guest) ? guest.checkInDetails?.checkedIn : guest.checkIn?.created);
export const getGuestCheckInDate = (guest) => isGuestV2(guest) ? guest.checkInDetails?.checkInDate : guest.checkIn?.created;
export const getRsvpAdditionalGuestName = (guest) => guest.fullName;
export const getRsvpGuestId = (guest) => (isGuestV2(guest) ? guest.guestId : guest.id);
export const getRsvpFormSubmissions = (rsvp) => rsvp.formSubmission?.submissions;
export const resolveGuestDetails = (submissions, event) => {
    const { first_name, last_name, email, rsvp_status, additional_guests } = submissions;
    const status = event ? resolveRsvpStatus(event, rsvp_status) : rsvp_status;
    const guestCount = additional_guests?.length || 0;
    const additionalGuests = additional_guests?.map(guest => ({
        firstName: guest.additional_guest_first_name,
        lastName: guest.additional_guest_last_name,
    }));
    return {
        firstName: first_name,
        lastName: last_name,
        email,
        status,
        additionalGuestDetails: guestCount ? { guestCount, additionalGuests } : undefined,
    };
};
export const resolveRsvpStatus = (event, response) => {
    const waitlistOpen = isWaitlistOpen(event);
    if (waitlistOpen && response !== RsvpStatusV2.NO) {
        return RsvpStatusV2.WAITLIST;
    }
    return response ?? RsvpStatusV2.YES;
};
